<template>
  <div v-if="inline" class="color-picker-inline">
    <button
      v-for="opt in colorOptions"
      :key="opt.value"
      type="button"
      class="color-swatch"
      :class="opt.icon"
      :style="opt.value === 'none' ? null : { color: opt.value }"
      :aria-label="opt.value"
      @click="selectColor(opt.value)"
    ></button>
  </div>
  <div v-else class="dropdown-center">
    <i
      ref="colorBtn"
      class="header-menu-icons bi-circle-fill color-picker-btn"
      type="button"
      data-bs-toggle="dropdown"
      data-bs-popper-config='{"strategy":"fixed","placement":"bottom-end"}'
      :style="'color: ' + color"
      :title="$t('todoDetails.color')"
    ></i>

    <ul class="dropdown-menu color-picker-dropdown px-2">
      <div class="d-flex align-items-center">
        <i class="bi-circle colors-menu-icons" type="button" @click="selectColor('none')"></i>
        <i class="bi-circle-fill colors-menu-icons" type="button" @click="selectColor('#77e785')"
          style="color: #77e785"></i>
        <i class="bi-circle-fill colors-menu-icons" type="button" @click="selectColor('#06b6d4')"
          style="color: #06b6d4"></i>
        <i class="bi-circle-fill colors-menu-icons" type="button" @click="selectColor('#5e6ef2')"
          style="color: #5e6ef2"></i>
      </div>
      <div>
        <i class="bi-circle-fill colors-menu-icons" type="button" @click="selectColor('#8b5cf6')"
          style="color: #8b5cf6"></i>
        <i class="bi-circle-fill colors-menu-icons" type="button" @click="selectColor('#ed56a1')"
          style="color: #ed56a1"></i>
        <i class="bi-circle-fill colors-menu-icons" type="button" @click="selectColor('#ed544b')"
          style="color: #ed544b"></i>
        <i class="bi-circle-fill colors-menu-icons" type="button" @click="selectColor('#f97316')"
          style="color: #f97316"></i>
      </div>
      <div>
        <i class="bi-circle-fill colors-menu-icons" type="button" @click="selectColor('#f9d54a')"
          style="color: #f9d54a"></i>
        <i class="bi-circle-fill colors-menu-icons" type="button" @click="selectColor('#ba7956')"
          style="color: #ba7956"></i>
        <i class="bi-circle-fill colors-menu-icons" type="button" @click="selectColor('#6b7280')"
          style="color: #6b7280"></i>
        <i class="bi-circle-fill colors-menu-icons" type="button" @click="selectColor('#030712')"
          style="color: #030712"></i>
      </div>
    </ul>
  </div>
</template>

<script>
const COLOR_OPTIONS = [
  { value: "none", icon: "bi-circle" },
  { value: "#77e785", icon: "bi-circle-fill" },
  { value: "#06b6d4", icon: "bi-circle-fill" },
  { value: "#5e6ef2", icon: "bi-circle-fill" },
  { value: "#8b5cf6", icon: "bi-circle-fill" },
  { value: "#ed56a1", icon: "bi-circle-fill" },
  { value: "#ed544b", icon: "bi-circle-fill" },
  { value: "#f97316", icon: "bi-circle-fill" },
  { value: "#f9d54a", icon: "bi-circle-fill" },
  { value: "#ba7956", icon: "bi-circle-fill" },
  { value: "#6b7280", icon: "bi-circle-fill" },
  { value: "#030712", icon: "bi-circle-fill" },
];

export default {
  name: "colorPicker",
  emits: ["ColorSelected"],
  props: {
    color: { required: true, type: [String, null] },
    inline: { type: Boolean, default: false },
  },
  data() {
    return { colorOptions: COLOR_OPTIONS };
  },
  mounted() {
    this.updateBtnShape(this.color);
  },
  methods: {
    selectColor(color) {
      this.$emit("ColorSelected", color);
    },
    updateBtnShape(color) {
      const btn = this.$refs.colorBtn;
      if (!btn) return;
      if (color == "none") {
        btn.classList.remove("bi-circle-fill");
        btn.classList.add("bi-circle");
      } else {
        btn.classList.add("bi-circle-fill");
        btn.classList.remove("bi-circle");
      }
    },
  },
  watch: {
    color(newVal) {
      this.updateBtnShape(newVal);
    },
  },
};
</script>

<style scoped lang="scss">
@import "/src/assets/style/globalVars.scss";

.header-menu-icons {
  margin-left: 6px;
  @include btn-icon;
}

.colors-menu-icons {
  margin-left: 1px;
  @include btn-icon;
}

.color-picker-dropdown {
  min-width: 7rem;

  i {
    margin-right: 0px;
  }
}

.color-picker-inline {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px 8px;
  width: 100%;
  padding: 4px 0;
}

.color-swatch {
  border: none;
  background: transparent;
  font-size: 1.55rem;
  line-height: 1;
  padding: 6px;
  color: rgba(60, 60, 67, 0.35);
}
</style>
